import { createApp } from "vue";
import App from "./src/App.vue";
const container = document.getElementById('newsboard-app');
if (container) {
    const app = createApp(App);
    app.mount(container);
}
else {
    console.error("Cannout find newsboard container!");
}
